import { render, staticRenderFns } from "./EditShape.vue?vue&type=template&id=5892b3dd&"
import script from "./EditShape.vue?vue&type=script&lang=js&"
export * from "./EditShape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports